import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { useMakeDecisionDialog } from './MakeDecision';

const useWithdrawDialog = () => {
  const { t } = useTranslation();
  const makeDecision = useMakeDecisionDialog();
  return useCallback(
    async (isTeamPlayersTable: boolean, isAlternate: boolean, isTeam: boolean) => {
      return await makeDecision(
        isTeamPlayersTable || !isTeam
          ? t('withdrawPlayers')
          : isAlternate
            ? t('withdrawAlternateTeams')
            : t('withdrawSelectedTeams'),
        isTeamPlayersTable || !isTeam ? t('withdrawPlayersModalText') : t('withdrawTeamModalText'),
        t('withdraw'),
      );
    },
    [makeDecision, t],
  );
};
export default useWithdrawDialog;
